module.exports = __webpack_public_path__ + "static/img/thumb-03.134bd63.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/shipping-label/dhl/thumb/thumb-03.png
// module id = c8AP
// module chunks = 31